import { render, staticRenderFns } from "./SellFactors.vue?vue&type=template&id=f423382c&"
import script from "./SellFactors.vue?vue&type=script&lang=js&"
export * from "./SellFactors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports